var TemplateLibraryLoadingView;

TemplateLibraryLoadingView = Marionette.ItemView.extend( {
	id: 'kitbuilder-template-library-loading',

	template: '#tmpl-kitbuilder-template-library-loading'
} );

module.exports = TemplateLibraryLoadingView;
